import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import OriginalsExpandedShopCard from '@wix/da-shared-react/pkg/ShopCard/OriginalsExpandedShopCard';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import Flex from '@wix/da-ds/pkg/Flex';
import { ShopItemType } from '../../../../../types/shop';
import OriginalsEmptyState from '../_partials/OriginalsEmptyState';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { AppState } from '../../../../../types/store';

export interface Props {
  className?: string;
}

export const ShopOriginals: FC<Props> = ({ className }) => {
  const streamId: string = getShopItemsStreamId(ShopItemType.ORIGINALS);
  const { items: deviationIds } = useStream(streamId);
  const deviations: PapiDeviation[] = useSelector((state: AppState) =>
    getDeviationsByIds(state, deviationIds)
  );

  return (
    <BiLoggerContextProvider value={{ sectionname: 'originals' }}>
      <Flex direction="column" gap={32}>
        {deviations.length === 0 && <OriginalsEmptyState view={'wide'} />}

        {deviations.map(deviation => (
          <OriginalsExpandedShopCard
            key={deviation.deviationId}
            deviation={deviation}
          />
        ))}
      </Flex>
    </BiLoggerContextProvider>
  );
};

ShopOriginals.displayName = 'ShopOriginals';
export default ShopOriginals;
